import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {ProjectStatusWrapper, RichTextWrapper, TopRow} from '../project_health_styles/ProjectStatus.styled';
import {StatusIndicator} from './StatusIndicator';
import RichTextItem from '../../../../components/richtext_item';
import Util from '../../../../forecast-app/shared/util/util';

const ProjectStatus = ({projectStatus}) => {
	const creationDate = Util.CreateNonUtcMomentDate(projectStatus.year, projectStatus.month, projectStatus.day);

	return (
		<ProjectStatusWrapper>
			<TopRow>
				<StatusIndicator projectStatusColor={projectStatus.color} />
				<span>{projectStatus.person.fullName + ' - ' + creationDate.format(Util.GetShortYearMomentFormat('ll'))}</span>
			</TopRow>
			<RichTextWrapper>
				<RichTextItem
					cy={'status-description'}
					projectLocked={false}
					alwaysShowControls={false}
					readOnly={true}
					text={projectStatus.description}
					placeholder={''}
				/>
			</RichTextWrapper>
		</ProjectStatusWrapper>
	);
};

export default createFragmentContainer(ProjectStatus, {
	projectStatus: graphql`
		fragment ProjectStatus_projectStatus on ProjectStatus {
			id
			person {
				id
				fullName
				profilePictureId
				profilePictureDefaultId
			}
			description
			color
			day
			month
			year
		}
	`,
});
